import { QuickSelectOption, getQuickSelectOptions } from '@saasalerts/ui'
import moment from 'moment'

const [
  todayOption,
  last24HoursOption,
  last7DaysOption,
  lastMonthOption,
  last3MonthsOption,
  last6MonthsOption,
  last1YearOption,
] = getQuickSelectOptions([
  'today',
  'last24Hours',
  'last7Days',
  'lastMonth',
  'last3Months',
  'last6Months',
  'last1Year',
])

export const dateRangeQuickSelectOptions: QuickSelectOption[] = [
  todayOption,
  last24HoursOption,
  last7DaysOption,
  lastMonthOption,
  last3MonthsOption,
  last6MonthsOption,
  last1YearOption,
]

const buildSingleDateOption = (
  label: string,
  value: number,
  unit: moment.unitOfTime.DurationConstructor
): QuickSelectOption => ({
  label,
  isRelative: true,
  getValue: () => {
    const start = moment().subtract(value, unit).startOf('day')
    return {
      start: start.toDate(),
      end: start.clone().endOf('day').toDate(),
    }
  },
})

export const singleDateQuickSelectOptions: QuickSelectOption[] = [
  buildSingleDateOption('Today', 0, 'day'),
  buildSingleDateOption('Yesterday', 1, 'day'),
  buildSingleDateOption('2 days ago', 2, 'day'),
  buildSingleDateOption('7 days ago', 7, 'day'),
  buildSingleDateOption('10 days ago', 10, 'day'),
  buildSingleDateOption('15 days ago', 15, 'day'),
  buildSingleDateOption('1 month ago', 1, 'month'),
  buildSingleDateOption('3 months ago', 3, 'month'),
  buildSingleDateOption('6 months ago', 6, 'month'),
]
